export const APPLE_MOBILE_NAV_OPEN = "apple-clone:open-mobile-nav";
export const APPLE_MOBILE_NAV_CLOSE = "apple-clone:close-mobile-nav";
export const APPLE_MOBILE_NAV_TOGGLE = "apple-clone:toggle-mobile-nav";
export const APPLE_MOBILE_NAV_STATE = "apple-clone:mobile-nav-state";
// Opens the desktop "floating" sidebar (used on immersive detail/Reels pages).
export const APPLE_FLOATING_NAV_OPEN = "apple-clone:open-floating-nav";

export function openAppleFloatingNav() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(APPLE_FLOATING_NAV_OPEN));
  }
}

function dispatchState(open) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(APPLE_MOBILE_NAV_STATE, { detail: { open: Boolean(open) } }));
  document.body.classList.toggle("apple-mobile-nav-open", Boolean(open));
}

export function openAppleMobileNav() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(APPLE_MOBILE_NAV_OPEN));
  }
}

export function closeAppleMobileNav() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(APPLE_MOBILE_NAV_CLOSE));
  }
}

export function toggleAppleMobileNav() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(APPLE_MOBILE_NAV_TOGGLE));
  }
}

export function publishAppleMobileNavState(open) {
  dispatchState(open);
}

export function subscribeAppleMobileNavState(onChange) {
  if (typeof window === "undefined") return () => {};
  const handler = (event) => onChange(Boolean(event.detail?.open));
  window.addEventListener(APPLE_MOBILE_NAV_STATE, handler);
  onChange(document.body.classList.contains("apple-mobile-nav-open"));
  return () => window.removeEventListener(APPLE_MOBILE_NAV_STATE, handler);
}
